import React from "react";
import { Helmet } from "react-helmet";
import MonetizeKnowledge from "../components/MonetizeKnowledge/MonetizeKnowledge";
import { eventConfig } from "../data/monetizeEventData";

const MonetizeKnowledgePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>
          Monetize Knowledge — Digital Income Blueprint | Adeolu Adegbemi
        </title>
        <meta
          name="description"
          content="Monetize Knowledge — a hands-on live event by Adeolu Adegbemi (The Blueprint Architect). Learn a tested system to turn your skills into ₦100K–₦300K/month while keeping your job. Reserve your seat today."
        />
        <meta
          name="keywords"
          content="Monetize knowledge, digital income, online business, Adeolu Adegbemi, Digital Income Blueprint, DBC, live event, workshop, passive income, Nigerian professionals"
        />
        <meta name="author" content="Adeolu Adegbemi" />

        {/* Open Graph */}
        <meta property="og:type" content="event" />
        <meta
          property="og:url"
          content="https://adeoluadegbemi.com/events/monetize-knowledge"
        />
        <meta
          property="og:title"
          content="Monetize Knowledge — Live Event | Adeolu Adegbemi"
        />
        <meta
          property="og:description"
          content="One-day intensive to help Nigerian professionals convert their knowledge into recurring income. Join a practical workshop to build a launch-ready offer and sales system."
        />
        <meta
          property="og:image"
          content="https://adeoluadegbemi.com/og-image-monetize-knowledge.jpg"
        />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://adeoluadegbemi.com/events/monetize-knowledge"
        />
        <meta
          property="twitter:title"
          content="Monetize Knowledge — Live Event | Adeolu Adegbemi"
        />
        <meta
          property="twitter:description"
          content="Practical one-day system to build ₦100K–₦300K/month from your expertise. Seats limited — reserve now."
        />
        <meta
          property="twitter:image"
          content="https://adeoluadegbemi.com/twitter-image-monetize-knowledge.jpg"
        />

        {/* Canonical + robots + viewport */}
        <link
          rel="canonical"
          href="https://adeoluadegbemi.com/events/monetize-knowledge"
        />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <main>
        <MonetizeKnowledge {...eventConfig} />
      </main>
    </>
  );
};

export default MonetizeKnowledgePage;
